import { FC, useMemo } from 'react';
import Constraints from 'src/shared-components/Constraints/Constraints';
import NextImage from 'src/shared-components/NextImage/NextImage';
import { DoctorReviewer } from 'src/api/types';
import dayjs from 'dayjs';
import { getCDNDoctorImageURL } from 'src/utils/cdnStaticSourcesHelper';
import { FormattedMessage } from 'react-intl';
import { useRouter } from 'next/router';
import trns from './trns';

const verifiedIcon = 'doctor_reviewer/verified.svg';

interface Props {
  doctorReviewer?: DoctorReviewer;
}

const DoctorCardContainer: FC<Props> = ({ doctorReviewer }) => {
  const router = useRouter();

  const imageSrcProps = useMemo(() => {
    const imgPngSrc = getCDNDoctorImageURL(doctorReviewer?.id, 'png');
    return {
      loader: () => imgPngSrc,
      src: imgPngSrc,
      pureSrc: true
    };
  }, [doctorReviewer?.id]);

  return (
    <div className="m:flex">
      <Constraints className="w-full">
        <div className="flex flex-col w-full items-center justify-center mt-8">
          <div className="flex flex-row w-full gap-4">
            <div className="py-5 h-full flex-1" key={doctorReviewer?.id}>
              <div className="flex flex-row sm:w-max m:items-center rounded border border-alto bg-wildSand px-2 py-1">
                <NextImage
                  alt="verified"
                  src={verifiedIcon}
                  layout="fixed"
                  height={18}
                  width={18}
                />
                <div className="fs-body-reg pl-2.5">
                  <FormattedMessage
                    {...trns.verified}
                    values={{
                      date: (
                        <span>
                          {new Date(
                            dayjs(doctorReviewer.reviewDate).format(
                              'YYYY MM DD'
                            )
                          ).toLocaleString(
                            `${router.locale === 'ru' ? 'ru-RU' : 'uk-UA'}`,
                            {
                              year: 'numeric',
                              month: 'long',
                              day: 'numeric'
                            }
                          )}
                        </span>
                      )
                    }}
                  />
                </div>
              </div>
              <div className="flex flex-row items-center mt-5">
                <div>
                  <NextImage
                    alt="doctor"
                    src={imageSrcProps}
                    layout="fixed"
                    height={56}
                    width={56}
                    {...imageSrcProps}
                  />
                </div>
                <div className="pl-2.5">
                  <div className="text-black fs-body-bold">
                    {doctorReviewer.name}
                  </div>
                  <div className="text-black fs-caption-reg">
                    {doctorReviewer.speciality}
                  </div>
                  <div className="text-silver fs-caption-reg">
                    <FormattedMessage
                      {...trns.experience}
                      values={{
                        experience: <span>{doctorReviewer.experience}</span>
                      }}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Constraints>
    </div>
  );
};

export default DoctorCardContainer;
